module.exports = __webpack_public_path__ + "img/giftCard.d519b2ac.svg";